import { useLocation } from 'wouter';
import { ArrowLeftRight } from 'lucide-react';
import { useAuth } from '@/_core/hooks/useAuth';
import { goToPortal } from '@/utils/openPortal';
import {
  allowedPortals,
  hasMultiplePortals,
  portalFromPath,
  portalLabel,
  setPreferredPortal,
  type PortalKind,
} from '@/utils/portalRouting';

export default function PortalSwitcher() {
  const { user } = useAuth();
  const [location, navigate] = useLocation();

  if (!user || !hasMultiplePortals(user)) return null;

  const current = portalFromPath(location);
  const targets = allowedPortals(user).filter((portal) => portal !== current);

  if (targets.length === 0) return null;

  const switchTo = (portal: PortalKind) => {
    setPreferredPortal(portal);
    goToPortal(portal, navigate);
  };

  return (
    <div className="mb-2 space-y-1">
      {targets.map((portal) => (
        <button
          key={portal}
          type="button"
          onClick={() => switchTo(portal)}
          className="w-full flex items-center gap-2 rounded-lg px-3 py-2 text-xs text-white/40 hover:text-white/70 hover:bg-white/5 transition-colors"
        >
          <ArrowLeftRight className="h-3.5 w-3.5 shrink-0" />
          {portalLabel(portal)}
        </button>
      ))}
    </div>
  );
}
